import { Component, OnInit } from '@angular/core';
import { SubscriptionRequest } from "../../models/SubscriptionRequest"
import { SubscriptionEvent } from "../../models/SubscriptionEvent"

import { FormGroup, FormControl } from '@angular/forms';
import { IsoeventsubscriptionmangementserviceService } from '../../services/isoeventsubscriptionmangementservice.service';
import { ActivatedRoute } from '@angular/router';
import { promise } from 'protractor';
import { PrenormalizedTemplateMetadata } from '@angular/compiler';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-unsubscribefromnotification',
  templateUrl: './unsubscribefromnotification.component.html',
  styleUrls: []
})
export class UnsubscribefromnotificationComponent implements OnInit {


  pageHeading: string = "Unsubscribe notifications";

  step1: string = "Step 1";
  step2: string = "Step 2";
  currentStep: string = null;
  listId: string = null;
  uniqueName: string = null;
  userEmail: string = null;
  userMessage: string = null;
  isoEvents: SubscriptionEvent[];

  selecteList:SubscriptionEvent = null;
  submitted: boolean = false;
  requestProcessed: boolean = false;
  messageToDisplay: string = "";
  requestFailed: boolean = false;
  dataLoaded: boolean = false;

  constructor(
    private eventService: IsoeventsubscriptionmangementserviceService,
    private route: ActivatedRoute,
    private titleService:Title) { }


  async ngOnInit(): Promise<void> {

    this.currentStep = this.step1; 

    this.route.queryParams.subscribe(params => {
      this.userEmail = params['email'];
      this.listId = params['listid'];
      this.uniqueName = params['uid'];
  }); 

    if (this.listId) {



      await this.eventService.getEventDetails().then(data => {
        this.isoEvents = data

        let matchingLists = this.isoEvents.filter((obj)=>{
          return obj.eventId == this.listId;
        })
        if(matchingLists && matchingLists.length>0)
        {
          this.selecteList = matchingLists[0];
          this.pageHeading  = "Unsubscribe from "+ this.selecteList.eventName;
          this.titleService.setTitle(this.pageHeading);
          this.messageToDisplay="'"+this.userEmail+"' has been successfully unsubscribed from "+this.selecteList.eventName+".";
        
        } 
      });

      //// load the subscription details based on source id
      await this.eventService.unsubscribeNotificationEventAsync( 
        this.userEmail,
        this.listId, 
        this.uniqueName ).then(data => {
          this.requestProcessed= true; 
        }
      )
      .catch(err => {
        this.requestFailed= true;
        this.messageToDisplay="Something went wrong. Failed to process the request try again or contact the support team.";
      });
      this.dataLoaded = true;
    } 

  }
}
